import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  FunctionField,
} from 'react-admin';

export const BrandShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="slug" />
      <TextField source="description" />
      
      <FunctionField
        label="Logo"
        render={(record: any) => {
          const logo = record.logo;
          if (!logo) return null;
          
          // Use thumbnail if available, otherwise fallback to original
          const imageUrl = logo.thumbnails?.find((t: any) => t.size === 'medium')?.url || logo.url;
          
          return (
            <img 
              src={imageUrl} 
              alt={record.name} 
              style={{ maxWidth: 200, maxHeight: 200, objectFit: 'cover' }} 
            />
          );
        }}
      />
      
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
